export const foodSupplementQueryKeys = {
  all: ['food-supplements'] as const,
  byId: (id: number) => ['food-supplements', id] as const,
};
